import React, { ReactElement, useEffect, useState } from 'react';
import { DemandOrderDto, OrderDto, ReturnOrderDto } from '../../api/ClientApi';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { Box, Chip, Grid2, Typography } from '@mui/material';
import { OrderStatusSR, SpecializedOrderStatusSR } from '../../common/Types';
import { getColorForOrderStatus, getSiteOrdersTableData } from './OrdersHelper';
import { getColorForSpecializedOrderStatus } from '../purchaseOrders/PurchaseOrdersHelper';

type OrderInfoExtendedProps = {
    order?: OrderDto;
    demandOrder?: DemandOrderDto;
    returnOrder?: ReturnOrderDto;
};

export default function OrderInfoExtended(props: OrderInfoExtendedProps): ReactElement {
    const { order, demandOrder, returnOrder } = props;

    const sites = useSelector((state: RootState) => state.sites.sites);
    const clients = useSelector((state: RootState) => state.clients.clients);

    const [originInfo, setOriginInfo] = useState<string>('/');
    const [destinationInfo, setDestinationInfo] = useState<string>('/');

    useEffect(() => {
        if (!!order) {
            const destinationSite = order.destinationSite;
            const originSite = order.originSite;
            const supplier = order.supplier;

            const destinationData = !destinationSite
                ? '/'
                : getSiteOrdersTableData(destinationSite, sites ?? undefined, clients ?? undefined);

            const originData = !originSite
                ? '/'
                : getSiteOrdersTableData(originSite, sites ?? undefined, clients ?? undefined);

            setOriginInfo(originData);
            setDestinationInfo(destinationData);
        }

        if (!!demandOrder) {
            const destinationSite = demandOrder.destinationSite;

            const destinationData = !destinationSite
                ? '/'
                : getSiteOrdersTableData(destinationSite, sites ?? undefined, clients ?? undefined);

            setDestinationInfo(destinationData);
        }

        if (!!returnOrder) {
            const originSite = returnOrder.originSite;

            const originData = !originSite
                ? '/'
                : getSiteOrdersTableData(originSite, sites ?? undefined, clients ?? undefined);

            setOriginInfo(originData);
        }
    }, [order, demandOrder, returnOrder]);

    return (
        <Box sx={{ pl: 3, pt: 2, pr: 2, mb: 5, textAlign: 'start' }}>
            <Grid2 container spacing={0}>
                <Grid2 size={{ xs: 12, md: 5 }}>
                    <Typography variant="body1" className="info-text">
                        Izvor: <span style={{ fontWeight: 'bold' }}>{originInfo}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5 }}>
                    <Typography variant="body1" className="info-text">
                        Odredište: <span style={{ fontWeight: 'bold' }}>{destinationInfo}</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 2 }} sx={{ textAlign: 'center' }}>
                    {!!order?.orderStatus && (
                        <Chip
                            variant="outlined"
                            label={OrderStatusSR[order.orderStatus]}
                            color={getColorForOrderStatus(order.orderStatus)}
                        />
                    )}
                    {!!demandOrder?.demandOrderStatus && (
                        <Chip
                            variant="outlined"
                            label={SpecializedOrderStatusSR[demandOrder?.demandOrderStatus]}
                            color={getColorForSpecializedOrderStatus(demandOrder?.demandOrderStatus)}
                        />
                    )}
                    {!!returnOrder?.returnOrderStatus && (
                        <Chip
                            variant="outlined"
                            label={SpecializedOrderStatusSR[returnOrder?.returnOrderStatus]}
                            color={getColorForSpecializedOrderStatus(returnOrder?.returnOrderStatus)}
                        />
                    )}
                </Grid2>
            </Grid2>
        </Box>
    );
}
